import styled, { css } from 'styled-components';

export const Trigger = styled.div<{ $compact: boolean }>`
	display: flex;
	align-items: center;
	gap: 6px;
	color: ${({ theme }) => theme.gray[1000]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 4px;
	background: transparent;
	user-select: none;
	font-family: 'Inter', sans-serif;

	${({ $compact }) =>
		$compact
			? css`
					height: 28px;
					padding: 0 8px;
					font-size: 13px;
					gap: 6px;
			  `
			: css`
					padding: 4px 8px;
					font-size: 13px;
			  `}

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const Swatch = styled.div<{ $color: string; $compact: boolean }>`
	width: ${({ $compact }) => ($compact ? 10 : 12)}px;
	height: ${({ $compact }) => ($compact ? 10 : 12)}px;
	border-radius: 50%;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ $color }) => $color};
	flex-shrink: 0;
`;

export const Label = styled.div`
	white-space: nowrap;
`;
